import React from 'react'
import { useMediaQuery } from '~/utils/hooks'

const Iframe = ({ data }) => {
  const isTablet = useMediaQuery('(min-width: 421px)')
  const isDesktop = useMediaQuery('(min-width: 1024px)')

  const styles = {
    iframe: (isTablet, isDesktop) => ({
      height: isDesktop
        ? data.desktopHeight
        : isTablet
          ? data.tabletHeight
          : data.mobileHeight,
    }),
  }

  return (
    <div className="row">
      <div className="col-12 lg-col-8 lg-col-offset-1">
        <h2 className="title-block text-blue">{data.title}</h2>
        <iframe
          style={styles.iframe(isTablet, isDesktop)}
          width="100%"
          height={data.desktopHeight}
          src={data.link}
          frameBorder="0"
          title={data.title}
        ></iframe>
      </div>
    </div>
  )
}

export default Iframe
